import TextField from "@mui/material/TextField";
import Select from "react-select";
import React, {useEffect, useState} from "react";
import {ApiUrl} from "../../../auth/authMethods";
import SelectInput from "../../../component/SelectInput";
import {typeList} from "./lists";
import {InputLabelProps} from "../../../utils/InputLabelProps";
import CurrencyInput from "../../../component/CurrencyInput";
import {handleChangeValue} from "../../../utils/handleChangeValue";
import FileInput from "../../../component/FileInput/FileInput";
import displayAlertMsg from "../../../component/AlertMsg/displayAlertMsg";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {handleChangeData} from "../../../utils/handleChangeData";
import {NumericFormat} from "react-number-format";
import Textarea from "@mui/joy/Textarea";

export default function InputsRecebivelRural({
                                                 setData, files, setFiles,
                                                 error, clear
                                             }) {

    const [participanteId, setParticipanteId] = useState("")
    const [tipo, setTipo] = useState(null)
    const [valor, setValor] = useState(0)
    const [vencimento, setVencimento] = useState('')
    const [multa, setMulta] = useState(2)
    const [juros, setJuros] = useState(1)
    const [observacao, setObservacao] = useState('')


    const [participantesList, setParticipantesList] = useState([])

    useEffect(() => {
        setData({
            participanteId,
            tipo,
            valor,
            vencimento,
            multa,
            juros,
            observacao
        })

    }, [participanteId, tipo, valor, vencimento, multa, juros, observacao])

    useEffect(() => {
        if (clear) {
            setParticipanteId("")
            setTipo(null)
            setValor(0)
            setVencimento('')
            setMulta(2)
            setJuros(1)
            setObservacao('')
            setFiles([])
        }
    }, [clear])


    return <>
        <br/>
        <SelectInput
            url={ApiUrl + '/participante/list?size=200000'}
            list={participantesList}
            set={setParticipantesList}
            defaultValue={participanteId}
            setObj={setParticipanteId}
            returnList={() => {
                let returnList = []
                participantesList.forEach((item) => {
                    returnList.push({value: item.id, label: `${item.nome} - ${item.documento}`})
                })
                return returnList
            }}
            placeholder={"Participante *"}
            required={true}
            fullWidth
        />

        <Select
            className="basic-single"
            classNamePrefix="select"
            id="form_select"
            isDisabled={false}
            isLoading={false}
            isClearable={true}
            isRtl={false}
            isSearchable={true}
            options={typeList}
            defaultValue={typeList.find(item => item.value === tipo)}
            onChange={(e) => setTipo(e?.value)}
            placeholder='Tipo'
        />

        <CurrencyInput
            label="Valor"
            customInput={TextField}
            prefix='R$'
            value={valor}
            inputProps={{
                min: 1,
                step: ".01"
            }}
            onValueChange={(e) => handleChangeValue(e, setValor)}
            InputLabelProps={InputLabelProps}
            className={'mt-2'}
            required
            fullWidth
        />

        <NumericFormat
            customInput={TextField}
            thousandSeparator="."
            decimalSeparator=","
            suffix=' %'
            decimalScale={2}
            label="Taxa por atraso (%)"
            max='999999'
            inputProps={{
                min: 1,
                max: 10,
                maxLength: 5,
                step: ".01"
            }}
            InputLabelProps={{
                style: {
                    zIndex: 0,
                },
            }}
            value={multa}
            onValueChange={(e) => handleChangeValue(e, setMulta)}
            required
            fullWidth
        />

        <NumericFormat
            customInput={TextField}
            thousandSeparator="."
            decimalSeparator=","
            suffix=' %'
            decimalScale={2}
            label="Taxa de juros por mês (%)"
            max='999999'
            inputProps={{
                min: 1,
                max: 10,
                maxLength: 5,
                step: ".01"
            }}
            InputLabelProps={{
                style: {
                    zIndex: 0,
                },
            }}
            value={juros}
            onValueChange={(e) => handleChangeValue(e, setJuros)}
            required
            fullWidth
        />

        <DatePicker
            label="Data de Vencimento"
            sx={{
                width: '100%'
            }}
            defaultValue={vencimento ? dayjs(vencimento) : null}
            onChange={(e) => handleChangeData(e, setVencimento)}
            slotProps={{
                textField: {
                    required: true
                },
            }}
        />

        <Textarea
            value={observacao}
            onChange={(e) => setObservacao(e.target.value)}
            placeholder='Observação'
            size="lg"
            variant="outlined"
            className="mt-3 mb-3"
            minRows={3}
            sx={{width: '70%', marginLeft: '15%'}}
        />

        <FileInput
            selectedFile={files}
            setSelectedFile={setFiles}
            multiple
        />

        {error && displayAlertMsg(error)}
        <br/>
    </>
}